import { createAction } from '@wix/communities-blog-client-common';

export const PAGINATION_CLEAR_COLLECTION = 'pagination/CLEAR_COLLECTION';

export const paginationClearCollection = createAction(PAGINATION_CLEAR_COLLECTION);
